import { useState } from "react";

export default function JSONTools() {
  const [keyPath, setKeyPath] = useState("");
  const [value, setValue] = useState("");
  const [textAreaValue, setTextAreaValue] = useState("");
  const [json, setJson] = useState({});
  const [resultNormalized, setResultNormalized] = useState(null);

  function buildNestedObject(path, val) {
    const keys = path.split(".");
    let result = {};
    let current = result;

    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        current[key] = val;
      } else {
        current[key] = {};
        current = current[key];
      }
    });

    return result;
  }

  function mergeObjects(target, source) {
    for (const key in source) {
      const sourceValue = source[key];
      const targetValue = target[key];

      const isSourceObject =
        typeof sourceValue === "object" &&
        sourceValue !== null &&
        !Array.isArray(sourceValue);

      const isTargetObject =
        typeof targetValue === "object" &&
        targetValue !== null &&
        !Array.isArray(targetValue);

      // Se ambos forem objetos, faz merge recursivo
      if (isSourceObject && isTargetObject) {
        target[key] = mergeObjects({ ...targetValue }, sourceValue);
      } else {
        // Caso contrário, sobrescreve completamente
        target[key] = sourceValue;
      }
    }

    return target;
  }

  function handleAdd() {
    if (!keyPath) return;

    const nested = buildNestedObject(keyPath, value);
    setJson((prev) => mergeObjects({ ...prev }, nested));

    setKeyPath("");
    setValue("");
  }

  function normalizeJson(jsonString) {
    try {
      const parsed = JSON.parse(jsonString);

      return {
        isValid: true,
        formatted: JSON.stringify(parsed, null, 2),
        error: null,
      };
    } catch (err) {
      return {
        isValid: false,
        formatted: null,
        error: err.message,
      };
    }
  }

  function handleNormalize() {
    const normalized = normalizeJson(textAreaValue);
    setResultNormalized(normalized);
  }

  return (
    <div style={{paddingTop:0}} className="row page-content pt-0">
      <div className="col-6 pb-4">
        <h3>Gerador de JSON Multinível</h3>
        <hr />
        <div className="form-group">
          <input
            className="form-control w-100 mb-2"
            placeholder="Chave (ex: user.address.city)"
            value={keyPath}
            onChange={(e) => setKeyPath(e.target.value)}
          />

          <input
            className="form-control w-100 mb-2"
            placeholder="Valor"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />

          <button className="btn btn-primary w-100" onClick={handleAdd}>
            Adicionar
          </button>

          <pre className="bg-dark text-white rounded p-3 mt-3">
            {JSON.stringify(json, null, 2)}
          </pre>
        </div>
      </div>
      <div className="col-6">
        <h3>Normalizar JSON</h3>
        <hr />
        <div className="form-group">
          <textarea
            className="form-control mb-2"
            rows={6}
            placeholder='Cole seu JSON aqui...'
            value={textAreaValue}
            onChange={(e) => setTextAreaValue(e.target.value)}
          />
          <button className="btn btn-secondary w-100" onClick={handleNormalize}>Normalizar</button>

          {resultNormalized && (
        <div style={{ marginTop: 15 }}>
          {resultNormalized.isValid ? (
            <>
              <p style={{ color: "green" }}>✅ JSON válido</p>
              <pre className="bg-dark text-white p-3 rounded">
                {resultNormalized.formatted}
              </pre>
            </>
          ) : (
            <>
              <p style={{ color: "red" }}>❌ JSON inválido</p>
              <pre style={{ background: "#ffecec", padding: 10 }}>
                {resultNormalized.error}
              </pre>
            </>
          )}
        </div>
      )}
        </div>
      </div>
    </div>
  );
}
